import React, { useEffect, useState } from 'react'
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api';
import MarkerInfoWindow from './InfoWindowBody';
import InfoWindowBody from './InfoWindowBody';
import pointMarker from "../../assets/images/icons/iconoubicacion.png"

const containerStyle = {
  height: '800px',
};

const divStyle = {
  background: `white`,
  border: `1px solid #ccc`,
  padding: 15
}

function MapGoogle({ markers, center, zoom, data, corralon, setCorralon}) {

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyAxiWJ5ssG3alt9Sf0iI50-M40mO2nOipo"
  })

  const [map, setMap] = React.useState(null)
  const [filteredData, setFilteredData] = useState({})
  const [showInfoWindow, setShowInfoWindow] = useState(false)
  const [position, setPosition] = useState({})

  useEffect(() => {
    if(corralon !== null) {
      setShowInfoWindow(false)
    }
  }, [corralon])
  
  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
    <GoogleMap
      id='googlemaps'
      mapContainerStyle={containerStyle}
      center={center}
      zoom={zoom}
      onUnmount={onUnmount}
    >
      { /* Child components, such as markers, info windows, etc. */}
      {markers &&
        markers.map((marker) => {
          return (
            <div key={marker.id}>
              <Marker
                position={marker.position}
                icon={pointMarker}
                onClick={() => {
                  setPosition(marker.position)
                  {corralon ? 
                    setFilteredData(data.find((object) => object.id === marker.id))
                    : 
                    setFilteredData(data.find((object) => object.province === marker.province))
                  }
                  setShowInfoWindow(true)
                  setCorralon(null)
                }} />
            </div>
          )
        })
      }
      {showInfoWindow &&
        <InfoWindow
          visible={showInfoWindow}
          position={position}
          corralon={corralon}
          onCloseClick={() => setShowInfoWindow(false)}
        >
          <InfoWindowBody {...filteredData} />
        </InfoWindow>
      }

     {/* {corralon &&
        <InfoWindow
          visible={corralon !== null ? true : false}
          position={{lat: Number(corralon.lat), lng: Number(corralon.long)}}
          onCloseClick={() => setCorralon(null)}
        >
          <InfoWindowBody {...corralon} />
        </InfoWindow>
      } */}


    </GoogleMap>
  ) : <></>
}

export default React.memo(MapGoogle)